import { componentsRegistryService } from "cruzo";
import { AbstractIcon } from "./abstract";

export class UserIcon extends AbstractIcon {
    static selector = "user-icon"

    getHTML() {
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path d="M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Zm0,8a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,16,16Z"/>
            <path d="M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM10,26.3765V25a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3v1.3765a11.8989,11.8989,0,0,1-12,0Zm13.9925-1.4507A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"/>
          </svg>`;
    }
}

componentsRegistryService.define(UserIcon);